import { AgGridReact } from "ag-grid-react";
import { Tabs } from "antd";
import styled from "styled-components";

export const StyledAgGrid = styled(AgGridReact)`
  font-size: 14px;
  color: #6d6d6d;

  .ag-root-wrapper {
    border: none;
  }
  .ag-center-cols-container .ag-row,
  .ag-header-container {
    background-color: #f9f9f9;
  }
  .ag-cell-inline-editing {
    padding: 15px 8px;
    input {
      border-radius: 8px;
    }
  }
  .ag-header {
    background: inherit;
    font-size: 11px;
  }
  .ag-header-cell {
    padding-left: 6px;
    padding-right: 6px;
  }
  .ag-header-cell-label {
    line-height: 14px;
  }
  .ordered-quantities-header {
    background-color: #f1f7ff;
    color: #181818;
  }
  .current-available-units-header {
    background-color: #feffd4;
    color: #181818;
  }
  .limit-quantity-header,
  .limit-quantity-header .ag-header-cell-text {
    font-weight: 900;
  }
  .ag-cell {
    display: flex;
    align-items: center;
    color: #6d6d6d;
    padding-left: 6px;
    padding-right: 6px;
  }
`;
export const StyledTabs = styled(Tabs)`
  margin-top: 0;
  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #181818 !important;
    font-weight: 700;
  }
  .ant-tabs-ink-bar {
    background-color: #183f23;
  }
  .ant-tabs-nav {
    margin: 0;
  }
  .ant-tabs-tab {
    padding: 4px 0;
  }
  .ant-tabs-tab-btn {
    color: #5c5c5c;
    font-size: 13px;
    padding: 0 28px;
  }
  .ant-tabs-content-holder {
    padding: 0;
  }
  .ant-tabs-tabpane {
    padding: 0 !important;
  }

  .ant-tabs-top {
    background: #f9f9f9 !important;
  }

  &.productTabs {
    .ant-tabs-tab {
      background: #f9f9f9 !important;
    }
  }
`;

export const ProductLengthBadge = styled.span`
  padding: 5px 10px;
  margin-left: 12px;
  font-size: 12px;
  border-radius: 8px;
  color: white;
  background-color: #c2aa73;
`;

export const StyledCardTabs = styled(Tabs)`
  margin-top: 4px;
  margin-left: -16px;
  margin-right: -16px;

  .ant-tabs-content-holder {
    background: #f9f9f9;
    padding: 0;
  }
  .ant-tabs-tabpane {
    padding: 0 !important;
  }

  .ant-tabs-tab {
    background: #ffffff !important;
    border: none !important;
    font-size: 16px;
  }

  .ant-tabs-tab-active {
    background: #f9f9f9 !important;
    border: 0;
  }

  .ant-tabs-nav {
    margin: 0;
  }

  .ant-tabs-tab-btn {
    padding: 4px 16px;
    color: #5c5c5c;
  }

  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #181818 !important;
    font-weight: 700;
  }

  .ant-tabs-tab-btn:hover {
    color: #181818 !important;
  }

  .ant-tabs-nav::before {
    display: none;
  }

  .ant-tabs-tab-active {
    border-bottom-color: #f9f9f9;
  }

  .ant-tabs-nav-list > .antd-tabs-tab {
    padding: 40px;
  }
`;
